import { Action } from '@ngrx/store';

export const GENERATE_CHILD_EXTRACTS_SUCCESS = '[Extract] Generate Child Extracts Success';

export class GenerateChildExtractsSuccessAction implements Action {
  readonly identifier = new Date().getTime().toString();
  readonly type = GENERATE_CHILD_EXTRACTS_SUCCESS;

  constructor(public payload: { fileGenerated: number }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GenerateChildExtractsSuccessAction.ts